(function() {
    // Poll for jQuery to come into existance
    var checkReady = function(callback) {
        if (window.jQuery) {
            callback(jQuery);
        }
        else {
            window.setTimeout(function() { checkReady(callback); }, 20);
        }
    };

    // Start polling...
    checkReady(function($) {
        $( "#customer_recovery form" ).on( "submit", function( event ) {
            setCookie('customer_recovery_email', $('#customer_recovery_email').val(), 5);
        });
      
        $(function() {
          	if ($('#recover-or-activate').length) {
              var email = getCookie('customer_recovery_email');
              if (!email) {
                  return;
              }
              var post_data = {
                email: email
              };

            
              $.ajax({
                  url: 'https://a1.seekinghealth.com/check-account.php',
                  type: 'POST',
                  data: post_data,
                  dataType: 'html',
                  success: function(data) {
                      data = JSON.parse(data);
                      var class_name = 'error';
                      if (data.error == 0) {
						  class_name = 'success';
                      }
                      $('#recover-or-activate').addClass('message--' + class_name);
                      $('#recover-or-activate > ul > li').text(data.message);
                  },
                  error: function() {
                      //alert("Something went wrong!");
                  },
                  complete: function() {
                      setCookie('customer_recovery_email', '', 1);
                  }
              });
            }
            
        });
    });
})();

function setCookie(cname, cvalue, exmins) {
  const d = new Date();
  d.setTime(d.getTime() + (exmins*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}